import memoize from 'memoize-one';

import type { EventHandlers } from '@atlaskit/editor-common/ui';

import type { RoutesContextType } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { smartCardEventHandler } from '@confluence/linking-platform/entry-points/smartCardEventHandler.ts';

export const createSmartCardEventHandler = memoize(
	(routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>): EventHandlers | undefined =>
		routesContext && typeof routesContext.push === 'function'
			? {
					smartCard: {
						onClick: (e, url) => smartCardEventHandler(routesContext, e, url),
					},
				}
			: undefined,
);
